/* eslint-disable */
import React, { Component } from "react";
import cookie, { select } from "react-cookies";
import $ from "jquery";

class CustomerAnalysis extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: '',
      multicheck: 'N',
      selectedcustid: []
    };
  }

  componentDidMount() {

  }

  handleMerchantClick(custData) {
      if(Object.keys(custData).length > 0 && custData.customerID != undefined && custData.customerID != ""  && custData.customerID != null) {
        this.props.openTragerPopup(custData.customerID);
      }
  }

  getDateFrmt = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  handleMulticheck() {
      let multicheck = this.state.multicheck;
      let selectedcustid = [];
      let customersPopularItemstData = [];
      if(this.props.customersPopularItemstData != "" && Object.keys(this.props.customersPopularItemstData).length > 0) {
          customersPopularItemstData = this.props.customersPopularItemstData;
      }
      if(multicheck == 'N') {
          multicheck = 'Y';
          selectedcustid = customersPopularItemstData.map(customersPopularItemst => customersPopularItemst.customerID);
      } else {
          multicheck = 'N';
          selectedcustid = [];
      }
      this.setState({ multicheck: multicheck, selectedcustid: selectedcustid }, function () {
        this.props.sateValChange('selectedcustomer', selectedcustid);
      });
      $(".customeranly_error_info").hide();
  }

  handleIndvlcheck(custid) {
    let selectedcustid = this.state.selectedcustid;
    if (selectedcustid.includes(custid)) {
      this.setState({ selectedcustid: selectedcustid.filter(m => m !== custid)}, function () {
          this.updateMultiSltBx();
      });
    } else {
      this.setState({ selectedcustid: [...selectedcustid, custid]}, function () {
          this.updateMultiSltBx();
      });
    }
    $(".customeranly_error_info").hide();
  }

  updateMultiSltBx() {
    let selectedcustid = this.state.selectedcustid;
    let multicheck = this.state.multicheck;
    let customersPopularItemstData = [];
    if(this.props.customersPopularItemstData != "" && Object.keys(this.props.customersPopularItemstData).length > 0) {
        customersPopularItemstData = this.props.customersPopularItemstData;
    }
    if(Object.keys(customersPopularItemstData).length > 0 && Object.keys(selectedcustid).length == Object.keys(customersPopularItemstData).length) {
        multicheck = 'Y';
    } else {
        multicheck = 'N';
    }
    this.setState({ multicheck: multicheck }, function () {
        this.props.sateValChange('selectedcustomer', selectedcustid);
    });
  }

  handleOpenGrpPoup() {
      let selectedcustid = this.state.selectedcustid;
      if(Object.keys(selectedcustid).length > 0) {
        this.props.openGroupPopup();
      } else {
        $(".customeranly_error_info").show().delay(5000).fadeOut();
      }
  }

  handleClick = (data) => {
    alert(`Filtering by ${data.name}`);
    // You could set a filter or state update here
  }

  render() {
    let customersPopularItemstData = [];
    if(this.props.customersPopularItemstData != "" && Object.keys(this.props.customersPopularItemstData).length > 0) {
        customersPopularItemstData = this.props.customersPopularItemstData;
    }
    return (<div className="spending_analysis_row customer_analysis_row">

              <div className="customeranly_maindiv">
                <div className="card customeranly_innerdiv">
                    <h5 className="topspenders_header">Customers  <a className="crt_group_link" onClick={this.handleOpenGrpPoup.bind(this)} href="javascript:void(0)">Create Customer Segment</a><div className="customeranly_error_info">Please select the customer.</div></h5>
                    <div className="topspenders_table_maindiv">
                      <table className="topspenders_table" style={{width:"100%"}}>
                        <tr>
                          <th style={{width:"3%"}}>
                            <div className="checkbox-cls">
                              <input type="checkbox" name="multicheck" value="Y" checked={(this.state.multicheck == 'Y')?true:false} className="multicheck_top" onChange={this.handleMulticheck.bind(this)} id="mul_check_top"/>
				                    </div>
                          </th>
                          <th style={{width:"20%"}}>Name</th>
                          <th style={{width:"15%"}}>Mobile</th>
                          <th style={{width:"14%"}}>First Purchase</th>
                          <th style={{width:"9%"}}>Receipts</th>
                          <th style={{width:"25%"}}>Top Item</th>
                          <th style={{width:"14%"}}>Total Spent</th>
                        </tr>
                        {customersPopularItemstData.length > 0 && (
                          customersPopularItemstData.map((item, index) => {
                            let transFirstDateObj = new Date(item.transFirstDate);
                            let transFirstDateTxt = this.getDateFrmt(transFirstDateObj);
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="checkbox-cls">
                                      <input type="checkbox" name="custid[]" checked={this.state.selectedcustid.includes(item.customerID)} onChange={this.handleIndvlcheck.bind(this,item.customerID)} value={item.customerID} className="multi_check" id={item.customerID} />
                                  </div>
                                </td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>{item.customerName}</td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>{item.customerPhone}</td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>{transFirstDateTxt}</td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>{item.totalTransCount}</td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>{item.transTopItem}</td>
                                <td onClick={this.handleMerchantClick.bind(this,item)}>${item.transAmount}</td>
                              </tr>
                            );
                          })
                        )}  
                      </table>
                    </div>
                </div>   
              </div>
                 
          </div>);
  }
}

export default (CustomerAnalysis);
